<template>
  <el-dialog
    :close-on-click-modal="false"
    title="子卡充值"
    :lock-scroll="true"
    :visible.sync="dialogFormVisible"
    width="480px"
  >
    <section v-loading="getDetailLoading">
      <div class="recharge-remark">
        <p class="title">操作流程说明：</p>
        <ol class="content">
          <li>1、充值后请到{{ this.$route.path.includes('gasCard') ?'气卡':'油卡'}}充值核销界面去审核。</li>
          <li>2、核销后到请登录服务商系统给子卡分配金额。</li>
          <li>3、到{{ this.$route.path.includes('gasCard') ?'气卡':'油卡'}}充值核销界面核销，充值完成，子卡理论余额增加。</li>
        </ol>
      </div>
      <qx-custom-form @sub="sub" :noSubBtn="true" ref="customForm" :formData="formData">
        <span class="parentOilCarNumTip" slot="parentOilCarNumTip" v-show="parentOilCarBalance !== ''">
          {{parentOilCarBalance}}元
        </span>
      </qx-custom-form>
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button
        type="primary"
        @click="customFormPost"
        :loading="subLoading || getDetailLoading"
      >确 定</el-button>
    </section>
  </el-dialog>
</template>

<script>
// import {
//   levelAllList,
// } from 'api/customer/level';
// import {
//   customerSetLevel,
// } from 'api/customer/customer';
import {
  doOilCardRecharge,
  toParentRecharge,
} from 'api/service';
export default {
  data () {
    return {
      parentOilCarBalance: '', // 主卡余额
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      type: '', // add/新增 edit/修改
      merLoading: false, // 商户选项loading中
      originData: {},
      formData: {
        form: [
          {
            label: '油卡卡ID',
            value: 'cardId',
            type: 'input',
            hide: true,
            readonly: true,
          },
          {
            label: '子卡卡号',
            value: 'oilCarNum',
            type: 'input',
            placeholder: '请输入子卡卡号',
            readonly: true,
          },
          {
            label: '油卡类型',
            value: 'oilCardTypeName',
            type: 'input',
            placeholder: '请输入油卡类型',
            readonly: true,
          },
          {
            label: '主卡卡号',
            value: 'parentOilCarNum',
            type: 'input',
            placeholder: '请输入主卡卡号',
            readonly: true,
          },
          {
            label: '余额',
            value: 'cardBalanceStr',
            type: 'input',
            unit: '元',
            placeholder: '请输入余额',
            readonly: true,
          },
          {
            label: '绑定车辆',
            value: 'plateNumber',
            type: 'input',
            placeholder: '请输入绑定车辆',
            readonly: true,
          },
          {
            label: '充值金额',
            value: 'preOilFee',
            type: 'input',
            unit: '元',
            placeholder: '请输入充值金额',
          },
        ],
        rules: { // 表单验证规则
          preOilFee: [ // 充值金额
            { required: true, message: '请输入充值金额', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {

    /**
     * @param {Object} item 修改的项
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    async show (item) {
      this.dialogFormVisible = true; // 打开弹窗
      this.$refs.customForm && this.$refs.customForm.reset();
      this.originData = item;
      this.getRechargeInfo(item);
      if (this.$route.path.includes('gasCard')) {
        this.$nextTick(() => {
          this.formData.form.forEach((item) => {
            if (item.label.includes('油卡')) {
              item.label = item.label.replace(/油卡/g, '气卡');
            }
            if (item.placeholder && item.placeholder.includes('油卡')) {
              item.placeholder = item.placeholder.replace(/油卡/g, '气卡');
            }
          });
        });
      }
      const res = await toParentRecharge({
        cardId: item.parentCardId,
      });
      if (!res.failed) {
        this.parentOilCarBalance = res.oilCardParentOut.cardBalanceStr;
      } else {
        this.parentOilCarBalance = '';
      }
    },

    customFormPost () {
      this.$refs.customForm.sub();
    },

    async getRechargeInfo (item) {
      const data = {
        oilCardTypeName: item.oilCardTypeName || '',
        oilCarNum: item.oilCarNum || '',
        cardBalanceStr: item.cardBalanceStr || '',
        companyName: item.companyName || '',
        parentOilCarNum: item.parentOilCarNum || '',
        plateNumber: item.plateNumber || '',
        preOilFee: '',
      };
      this.$nextTick(() => {
        this.$refs.customForm && this.$refs.customForm.setVal(data);
      });

      // const res = await toParentRecharge({
      //   cardId: item.cardId,
      // });
      // if (!res.failed) {
      //   const data = {
      //     oilCardTypeName: res.oilCardParentOut.oilCardTypeName || '',
      //     oilCarNum: res.oilCardParentOut.oilCarNum || '',
      //     cardBalanceStr: res.oilCardParentOut.cardBalanceStr || '',
      //     companyName: res.oilCardParentOut.companyName || '',
      //     acctName: res.accountBankRel.acctName || '',
      //     acctNo: res.accountBankRel.acctNo || '',
      //     branchName: res.accountBankRel.branchName || '',
      //     preOilFee: '',
      //   };
      //   this.$nextTick(() => {
      //     this.$refs.customForm && this.$refs.customForm.setVal(data);
      //   });
      // }
    },

    /**
     * @param {Object} form 表单数据
     * @returns {void}
     * @description 弹窗确定按钮事件
     */
    async sub (form) {
      if (this.originData.cardId) {
        this.subLoading = true;
        const res = await doOilCardRecharge({
          cardId: this.originData.cardId,
          preOilFee: Number((form.preOilFee * 100).toFixed(2)),
          cardCategory: this.$route.path.includes('gasCard') ? 2 : 1,
        });
        this.subLoading = false;
        if (!res.failed) {
          this.dialogFormVisible = false; // 关闭弹窗
          this.$message({
            type: 'success',
            message: '充值成功',
          });
          this.$emit('sub');
        }
      } else {
        this.$message({
          type: 'warning',
          message: '缺少卡信息',
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.recharge-remark {
  color: #999999;
  margin-top: -20px;
  margin-bottom: 10px;
  .title {
  }
  .content {
    line-height: 1.6;
    padding: 5px 0;
  }
}
.parentOilCarNumTip{
  color: #999;
  margin-left: 8px;
}
</style>
